import "./App.css";
import Navbar from "./component/Navbar";
import { Element } from "react-scroll";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Rooms from "./pages/Rooms";
import EventHall from "./pages/EventHall";
import Specialties from "./pages/Specialties";
import Book from "./pages/Book";
import Footer from "./pages/Footer";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div>
      <Navbar />

      <Element name="home">
        <Home />
      </Element>

      <Element name="rooms">
        <Rooms />
      </Element>

      <Element name="eventHall">
        <EventHall />
      </Element>

      <Element name="amenities">
        <Specialties />
      </Element>
      <Element name="about">
        <AboutUs />
      </Element>

      <Element name="book">
        <Book />
      </Element>
      <Element>
        <Footer />
      </Element>

       <Toaster position="top-right" />
    </div>
  );
}

export default App;
